import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';
import { CountryService } from 'src/app/country.service';
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  country = 'sg';
  constructor(private meta: Meta, private title: Title, private cs: CountryService, private canonicalService: CanonicalService) {
   
    // this.title.setTitle("Privacy Policy - SingX");
    // this.meta.addTags([
    //   { name: 'description', content: 'Follow Privacy Policy for SingX Group.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
    // ]);
  }

  ngOnInit(): void {
    this.country = this.cs.getCountry();
    if (this.country === 'sg') {
      this.title.setTitle("Privacy Policy - SingX");
      this.canonicalService.updateCanonicalUrl('/privacy-policy');
      this.meta.updateTag({ name: 'description', content: 'Follow Privacy Policy for SingX Group.' })
      this.meta.updateTag({ name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
    } else if (this.country === 'hk') {
      this.title.setTitle("Privacy Policy - SingX");
      this.canonicalService.updatehkCanonicalUrl('/privacy-policy');
      this.meta.updateTag({ name: 'description', content: 'Securely Sending Money from Hong Kong to any other country with SingX. Protecting your privacy is very important to us and its our Priority.' })
      this.meta.updateTag({name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'Money Transfer from Hong Kong, Money Transfer Overseas, Money Transfer Globally, International Money Transfer, International Business Payment, Fund Transfer Overseas, International Remittance, Money Exchangers.'})
    } else if(this.country === 'au'){
      this.title.setTitle("Privacy Policy - SingX");
      this.canonicalService.updateauCanonicalUrl('/privacy-policy');
      this.meta.updateTag({ name: 'description', content: 'Securely Sending Money from Australia to any other country with SingX. Protecting your privacy is very important to us and its our Priority.' })
      this.meta.updateTag({name: 'author', content: 'SingX' })
      this.meta.updateTag({ name: 'keywords', content: 'International Money Transfer from Australia, Money Transfer Overseas, Global Money Transfer, International Fund Transfer, International Remittance, Remit Money Overseas, Foreign Remittance, International Payment Transfer.'})
    } else {
      this.title.setTitle("Privacy Policy - SingX");
      this.meta.addTags([
        { name: 'description', content: 'Follow Privacy Policy for SingX Group.' },
        { name: 'author', content: 'SingX' },
        { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
      ], true);
    }
  }

}
